import React from 'react';
import LoadingOverlay from 'react-loading-overlay';

// custom loading overlay with properties setted

const CustomLoadingOverlay = ({ children, loader }) => {
  return (
    <LoadingOverlay
      active={loader}
      spinner
      styles={{
        wrapper: {
          minHeight: 'inherit'
        },
        overlay: (base) => ({
          ...base,
          position: 'fixed'
        })
      }}>
      {children}
    </LoadingOverlay>
  );
};

export default CustomLoadingOverlay;
